export function updatePageTitle(document, title) {
    document.title = title;
} 

export function updatePageDescription(document, description) {
    document.getElementsByTagName('meta')['description'].content = description;
}

export function changeStyleSheet (document, mode) {
    let c = this.colorMode == 'chiaro' ? 'light' : 'dark';
    document.getElementById("water-css").setAttribute("href", 'https://cdn.jsdelivr.net/npm/water.css@2/out/' + c + '.css');
}
